import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { IMG } from "@/lib/site";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;

export const Lead = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { toast.error("Signup is unavailable right now."); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/leads`, { email, source: "joint-genesis" });
      setDone(true);
      setEmail("");
      toast.success(data?.already ? "You're already on the list." : "You're in. Watch your inbox.");
    } catch (err) {
      toast.error(err?.response?.data?.detail?.[0]?.msg?.replace("Value error, ", "") ?? "Something went wrong. Try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="relative overflow-hidden bg-[#091D18] py-24 sm:py-32" data-testid="lead-section">
      <img src={IMG.beach} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-[#091D18]/70" />
      <div className="relative mx-auto max-w-3xl px-5 text-left sm:px-8">
        <Reveal>
          <Eyebrow>The gobbloo letter</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#F2EDE4] sm:text-5xl">
            Joint-friendly habits, <span className="font-serif italic font-normal text-[#D96B43]">in your inbox.</span>
          </h2>
          <p className="mt-5 max-w-lg text-base text-[#F2EDE4]/75">Occasional notes on mobility routines and new product reviews. No spam, unsubscribe anytime.</p>
          {done ? (
            <p className="mt-10 font-serif text-2xl italic text-[#E5A93C]" data-testid="lead-success-message">Thank you — you're on the list.</p>
          ) : (
            <form onSubmit={submit} className="mt-10 flex flex-col gap-3 sm:flex-row" data-testid="lead-form">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                data-testid="lead-email-input" aria-label="Email address"
                className="h-14 flex-1 rounded-full border border-[#F2EDE4]/20 bg-[#F2EDE4]/5 px-6 text-[#F2EDE4] placeholder:text-[#F2EDE4]/50 backdrop-blur-md outline-none transition-colors focus:border-[#D96B43]" />
              <button type="submit" disabled={busy} data-testid="lead-submit-button"
                className="flex h-14 items-center justify-center gap-2 rounded-full bg-[#D96B43] px-8 font-semibold text-[#091D18] transition-colors hover:bg-[#F2EDE4] disabled:opacity-60">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Subscribe <ArrowRight className="h-4 w-4" /></>}
              </button>
            </form>
          )}
        </Reveal>
      </div>
    </section>
  );
};
